import React from "react";

import "./App.css";
import Layout from "./layout";

const App = () => {
  return <Layout />;
};

export default App;
